<template>
    <TopRow v-if="$route.meta.showNavigation" :key="componentKey" ref="forceRerender" />
    <div class="container" style="padding-bottom: 20px;">
        <div class="row" style="margin-bottom: 15px">
            <router-view />
        </div>
    </div>
    <Footer />
</template>

<script>
import TopRow from "./components/TopRow.vue"
import Footer from "./components/Footer.vue"
import { getAuth } from "@/libs/auth"

console.log(`VUE_APP_ROOT_URL: ${process.env.VUE_APP_ROOT_URL}`);
console.log(`VUE_APP_API_BASE_URL: ${process.env.VUE_APP_API_BASE_URL}`);
console.log(`BASE_URL: ${process.env.BASE_URL}`);
async function buildAuth() {
    return getAuth()
}

import { useRoute } from 'vue-router'
import { computed } from 'vue'



export default {
    components: { TopRow, Footer },
/*
    setup() {
        const route = useRoute()

        const path = computed(() => route.path)
        const routeName = route.name
        const showNavigation = route.meta.showNavigation
        const outputFormat = route.query.of

        return {
            path: path,
            routeName:routeName,
            showNavigation: showNavigation,
            outputFormat: outputFormat
        }
    },
*/
    data() {
        return {
            outputFormat: this.outputFormat,
            componentKey: 0,
            theAuthCookie: buildAuth(),
        }
    },
    async mounted() {
        //setupAuthInfo(this.theAuthCookie)
        if (this.outputFormat == 1) {
            console.log("app outputFormat 1")
        }
        console.log(`routerName: ${this.routerName}, showNavigation: ${this.showNavigation}, outputFormat: ${this.outputFormat}, componentKey: ${this.componentKey}, theAuthCookie: ${this.theAuthCookie}`)
    },
    methods: {
        forceRerender() {
            //setupAuthInfo(this.theAuthCookie)
            this.componentKey += 1;
        }
    }
}
</script>

<style>
body {
    margin: 0;
}

#app {
    text-align: center;
    color: var(--qrce-text);
    background: transparent;
}
</style>
